import { TAXI_QUOTE_BRANDREF } from "../../config/config";
import { clearAllStores } from "../utils/storeUtils";

const brandRef = TAXI_QUOTE_BRANDREF;

export const loginWithUber = async (requestBody) => {
  try {
    clearAllStores();
    const response = await fetch("/portal/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorDetails = await response.json();
      throw new Error(
        `HTTP error! Status: ${response.status} - ${errorDetails.detail ||
          "Unknown error"}`
      );
    }

    return await response.json();
  } catch (error) {
    throw new Error(`Error fetching Uber details: ${error.message}`);
  }
};

export const getPolicies = async (customerId) => {
  try {
    const response = await fetch(
      `/getPolicies?customerId=${encodeURIComponent(customerId)}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      const errorDetails = await response.json();
      throw new Error(
        `HTTP error! Status: ${response.status} - ${errorDetails.detail ||
          "Unknown error"}`
      );
    }

    return await response.json();
  } catch (error) {
    throw new Error(`Error fetching policies: ${error.message}`);
  }
};

export const getCustomerPolicies = async (customerId) => {
  try {
    const response = await fetch(
      `/api/customerPolicies?customerId=${encodeURIComponent(
        customerId
      )}/${brandRef}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      const errorDetails = await response.json();
      throw new Error(
        `HTTP error! Status: ${response.status} - ${errorDetails.detail ||
          "Unknown error"}`
      );
    }

    return await response.json();
  } catch (error) {
    throw new Error(`Error fetching customer policies: ${error.message}`);
  }
};

// customerQuotes

export const getCustomerQuotes = async (customerId) => {
  try {
    const response = await fetch(
      `/api/customerQuotes?customerId=${encodeURIComponent(
        customerId
      )}/${brandRef}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      const errorDetails = await response.json();
      throw new Error(
        `HTTP error! Status: ${response.status} - ${errorDetails.detail ||
          "Unknown error"}`
      );
    }

    return await response.json();
  } catch (error) {
    throw new Error(`Error fetching customer policies: ${error.message}`);
  }
};

export const resetCustomer = async (requestBody) => {
  try {
    const response = await fetch(`/api/resetCustomer`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorDetails = await response.json();
      throw new Error(
        `HTTP error! Status: ${response.status} - ${errorDetails.detail ||
          "Unknown error"}`
      );
    }

    return await response.json();
  } catch (error) {
    throw new Error(`Error fetching customer policies: ${error.message}`);
  }
};
